<template>
<footer class="footer">
    <div class="footer-inner">
        <div class="footer-mobile">
            <v-row justify="center">
                <v-expansion-panels accordion tile flat>
                    <v-expansion-panel>
                        <v-expansion-panel-header class="title-footer">О НАС</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <ul class="panel__content">
                                <div v-if="getTemplate" v-html="getTemplate.hb1" @click="edit(getTemplate.hb1, 'hb1')" :class="getUser ? 'isEdit' : ''">
                                </div>
                            </ul>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                        <v-expansion-panel-header class="title-footer">ЛЕЧЕНИЕ АЛКОГОЛИЗМА</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <ul class="panel__content">
                                <div v-if="getTemplate" v-html="getTemplate.hb2" @click="edit(getTemplate.hb2, 'hb2')" :class="getUser ? 'isEdit' : ''">
                                </div>
                            </ul>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                        <v-expansion-panel-header class="title-footer">
                            ЛЕЧЕНИЕ НАРКОМАНИИ
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <ul class="panel__content">
                                <div v-if="getTemplate" v-html="getTemplate.hb3" @click="edit(getTemplate.hb3, 'hb3')" :class="getUser ? 'isEdit' : ''">
                                </div>
                            </ul>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                        <v-expansion-panel-header class="title-footer">
                            ВСЕ ГОРОДА
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <ul class="panel__content">
                                <li v-for="(item, index) in getCityList" :key="index">
                                    <a :href="'https://' + item.domain" class="tex-footer" route="ignore" target="_blank"> {{item.name}} </a>
                                </li>
                            </ul>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                </v-expansion-panels>
            </v-row>
            <v-col cols="12" class="text-info">
                <span v-if="getTemplate" v-html="getTemplate.hb5" @click="edit(getTemplate.hb5, 'hb5')" :class="getUser ? 'isEdit' : ''">
                </span>
            </v-col>
            <div class="footer__mobile-social">
                <div v-if="getTemplate" v-html="getTemplate.hb4" @click="edit(getTemplate.hb4, 'hb4')" :class="getUser ? 'isEdit' : ''">
                </div>
            </div>
        </div>

        <v-col cols="4" class="footer__item footer__form-u">
            <form class="footer-form">
                <div class="dropdown show">
                    <a class="btn btn-secondary dropdown-toggle city-select" href="#" role="button" id="dropdownMenuLink" route="ignore" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Все города
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <template v-for="(item, index) in getCityList">
                            <a :href="'https://' + item.domain" class="dropdown-item" route="ignore" target="_blank" :key="index"> {{item.name}} </a>
                        </template>
                    </div>
                </div>
            </form>
            <p class="text-info">
                <span  v-if="getTemplate" v-html="getTemplate.hb5" @click="edit(getTemplate.hb5, 'hb5')" :class="getUser ? 'isEdit' : ''">
                </span>
            </p>
        </v-col>
        <v-col cols="4" class="footer__item footer__medium-menu-2">
            <ul class="footer__item-list-top">
                <li>
                    <a class="title-footer" href="/about">
                        О НАС
                    </a>
                </li>
                <div v-if="getTemplate" v-html="getTemplate.hb1" @click="edit(getTemplate.hb1, 'hb1')" :class="getUser ? 'isEdit' : ''">
                </div>
            </ul>
            <ul class="footer__item-list-top">
                <li>
                    <a class="title-footer" href="/narkomania">
                        ЛЕЧЕНИЕ НАРКОМАНИИ
                    </a>
                </li>
                <div v-if="getTemplate" v-html="getTemplate.hb3" @click="edit(getTemplate.hb3, 'hb3')" :class="getUser ? 'isEdit' : ''">
                </div>
            </ul>
        </v-col>
        <v-col cols="3" class="footer__item footer__medium-menu-3">
            <ul class="footer__item-right">
                <li>
                    <a class="title-footer" href="/alcogolizm">
                        ЛЕЧЕНИЕ АЛКОГОЛИЗМА
                    </a>
                </li>
                <div v-if="getTemplate" v-html="getTemplate.hb2" @click="edit(getTemplate.hb2, 'hb2')" :class="getUser ? 'isEdit' : ''">
                </div>
            </ul>
            <ul class="footer__item-right-bottom">
                <div v-if="getTemplate" v-html="getTemplate.hb6" @click="edit(getTemplate.hb6, 'hb6')" :class="getUser ? 'isEdit' : ''">
                </div>
            </ul>
            <div class="footer__medium-social">
                <div v-if="getTemplate" v-html="getTemplate.hb4" @click="edit(getTemplate.hb4, 'hb4')" :class="getUser ? 'isEdit' : ''">
                </div>
            </div>
        </v-col>
        <v-col cols="1" class="footer__social">
            <div v-if="getTemplate" v-html="getTemplate.hb4" @click="edit(getTemplate.hb4, 'hb4')" :class="getUser ? 'isEdit' : ''">
            </div>
        </v-col>
    </div>

</footer>
</template>

<script>
import {
    mapGetters
} from "vuex";
export default {
    data: () => ({
        items: ["Москва", "Санкт-Петербург", "Ростов-на-Дону"],
        menu: ["Лечение алкоголизма", "Лечение наркомании"],
        isActive: true,
        currentCity: {},
        droverMenu: false,
        dialog: false,
        rating: 4,
    }),
    computed: mapGetters(["getTemplate", "getUser","getCityList"]),
    methods: {
        edit(code, block) {
            if (this.getUser) {
                this.$store.commit('setEditor', {
                    code: code,
                    block: block,
                    page: 'template'
                })
            }
        },
        changeCity() {
            window.location.href = 'http://' + this.currentCity;
        },
    },
};
</script>



// WEBPACK FOOTER //
// footer.vue?698141e0